import { adminSignIn, adminSignOut } from '@/services/adminAuthService'

const TOKEN_KEY = 'adminToken'
const USER_KEY = 'adminUser'

function loadStoredUser() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

const state = {
  token: localStorage.getItem(TOKEN_KEY) || null,
  user: loadStoredUser(),
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  currentUser: (state) => state.user,
}

const mutations = {
  SET_AUTH(state, { token, user }) {
    state.token = token
    state.user = user
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  },
  CLEAR_AUTH(state) {
    state.token = null
    state.user = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  },
}

const actions = {
  async login({ commit }, { login, password }) {
    const data = await adminSignIn(login, password)
    commit('SET_AUTH', { token: data.token, user: data.adminUser })
    return data
  },

  async logout({ commit, state }) {
    if (state.token) {
      try {
        await adminSignOut()
      } catch {
        // Clear local session even if sign-out request fails.
      }
    }
    commit('CLEAR_AUTH')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
